import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import style from './PasswordMain.module.scss';
import { Button, Heading, Card } from '@walmart-web/livingdesign-components';
import { useMediaQuery } from 'react-responsive';
import { useDispatch } from 'react-redux';
import { updateResetPassword } from '../../../redux/Account/slice';
import { environment } from '../../../utils/environment/environment';

const PasswordSuccess = () => {
	const isDesktop = useMediaQuery({ minWidth: 851 });
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();

	useEffect(() => {
		dispatch(
			updateResetPassword({
				nextScreen: 'ApplicationLogin',
				nextPath: '/login',
				status: 'SUCCESS'
			})
		);
	}, []);

	const handleLoginClick = () => {
		if (environment.isPingfed === 'true') {
			window.location.replace(environment.pingFedLoginUrl);
		} else {
			navigate('../applicant-login');
		}
	};

	return (
		<React.Fragment>
			<Card UNSAFE_className={style.card}>
				<div className={`${style.header}`}>
					<Heading size={isDesktop ? 'medium' : 'small'} as="h1" weight="700" color="#2E2F32">
						{t('passwordSuccessPage.passwordSuccessHeading')}
					</Heading>
				</div>
				<div className={`${style.body} ${style.body_icon}`}>
					<svg
						width="105"
						height="105"
						viewBox="0 0 105 105"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M52.1395 104.882C80.9077 104.882 104.229 81.5493 104.229 52.7666C104.229 23.9839 80.9077 0.650879 52.1395 0.650879C23.3713 0.650879 0.0500488 23.9839 0.0500488 52.7666C0.0500488 81.5493 23.3713 104.882 52.1395 104.882Z"
							fill="#D4E7CD"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M59.1791 21.9289C60.8437 22.7546 61.8528 24.6304 62.3159 26.8945C62.5455 28.0169 62.1622 31.642 61.1278 38.5284L60.6589 41.5843L76.6656 41.5845L77.0238 41.5961C80.2423 41.7823 82.7948 44.4471 82.7948 47.707C82.7948 49.875 81.6659 51.7798 79.9629 52.8674C80.4652 53.7536 80.751 54.7778 80.751 55.8687C80.751 58.0368 79.6221 59.9415 77.9191 61.0291C78.4214 61.9153 78.7073 62.9396 78.7073 64.0305C78.7073 66.1985 77.5784 68.1032 75.8754 69.1908C76.3777 70.077 76.6635 71.1013 76.6635 72.1922C76.6635 75.4521 74.111 78.1169 70.8925 78.3031L70.5323 78.3135H52.1385L51.9321 78.303C49.0207 78.0079 47.2511 77.5405 44.9623 76.5862L43.1454 75.8033C41.5723 75.1406 40.1735 74.6994 38.2454 74.3372L37.6483 74.2312L27.6135 74.2326C26.5653 74.2326 25.7015 73.4449 25.5835 72.4301L25.5697 72.1922V45.6666C25.5697 44.6202 26.3587 43.7578 27.3751 43.6399L27.6135 43.6262H37.8322C40.3705 43.6262 45.0725 41.0092 47.7361 37.522C48.4192 36.6278 49.3254 34.2901 50.2468 31.1602L50.5926 29.9507L50.8489 29.0072C51.3594 27.0878 51.8442 25.0375 52.0569 24.0102L52.1596 23.464C52.5901 20.4942 56.7347 20.7165 59.1791 21.9289ZM66.4448 70.1518C65.316 70.1518 64.401 69.2382 64.401 68.1113C64.401 67.0649 65.19 66.2025 66.2064 66.0846L66.4448 66.0709H72.576C73.7048 66.0709 74.6198 65.1574 74.6198 64.0305C74.6198 62.9841 73.8308 62.1216 72.8144 62.0038L72.576 61.99H68.4885C67.3598 61.99 66.4448 61.0765 66.4448 59.9496C66.4448 58.9032 67.2337 58.0408 68.2502 57.9229L68.4885 57.9092H74.6198C75.7485 57.9092 76.6635 56.9956 76.6635 55.8687C76.6635 54.8223 75.8746 53.9599 74.8581 53.842L74.6198 53.8283H70.5323C69.4035 53.8283 68.4885 52.9148 68.4885 51.7879C68.4885 50.7415 69.2775 49.8791 70.2939 49.7612L70.5323 49.7475H76.6635C77.7923 49.7475 78.7073 48.8339 78.7073 47.707C78.7073 46.6606 77.9183 45.7982 76.9019 45.6803L76.6635 45.6666H58.2698C57.0135 45.6666 56.0546 44.5457 56.2512 43.3069L57.0062 38.4267C57.966 32.039 58.4137 28.2128 58.3111 27.711C58.0754 26.5589 57.62 25.7124 57.3604 25.5836C57.1769 25.4926 56.7538 25.3835 56.3057 25.3167L55.991 25.2772L55.9627 25.4237C55.1385 29.5509 52.9631 37.0209 51.204 39.6887L50.9864 39.9966C47.7107 44.285 42.142 47.4724 38.2568 47.6946L37.8322 47.707L29.6572 47.7056V70.1503L37.8322 70.1518L38.1682 70.1795C40.8281 70.6221 42.6819 71.1788 44.7345 72.0435L46.0102 72.5957C48.0486 73.4819 49.4082 73.8981 51.6966 74.1717L52.2529 74.2312L70.5323 74.2326C71.661 74.2326 72.576 73.3191 72.576 72.1922C72.576 71.1458 71.7871 70.2833 70.7706 70.1655L70.5323 70.1518H66.4448Z"
							fill="black"
						/>
					</svg>
				</div>
				<div className={style.footer}>
					<Button
						size="medium"
						variant="primary"
						isFullWidth
						disabled={false}
						type="button"
						onClick={handleLoginClick}>
						{t('passwordSuccessPage.loginToAccount')}
					</Button>
				</div>
			</Card>
		</React.Fragment>
	);
};

export default PasswordSuccess;
